import { connect, fileUploading, previousQuestion, screenreaderNotification, QuizSession } from '@instructure/quiz-core';
import { TakeFooter as TakeFooterPresenter } from './presenter';
export function mapStateToProps(state, ownProps) {
  var quizSessionId = ownProps.quizSessionId;
  var quizSession = QuizSession.create(state.getIn(['quizSessions', quizSessionId]));
  var allowBacktracking = quizSession.get('allowBacktracking');
  var isOneQuestionAtATime = quizSession.isOneQuestionAtATime();
  var shouldRenderPrevious = allowBacktracking && ownProps.currentSessionItemPosition > 1;
  return {
    previousButtonDisabled: fileUploading(state),
    isOneQuestionAtATime: isOneQuestionAtATime,
    shouldRenderPrevious: shouldRenderPrevious
  };
}
export var mapDispatchToProps = {
  previousQuestion: previousQuestion,
  screenreaderNotification: screenreaderNotification
};
export var TakeFooter = connect(mapStateToProps, mapDispatchToProps)(TakeFooterPresenter);
export default TakeFooter;